export default __webpack_public_path__ + "static/media/Lasting Faith Tasset.99492cbb.jpg";